var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-cards" },
    _vm._l(_vm.localValue, function(order) {
      return _c("div", { key: order.ID, staticClass: "order-card mb-24" }, [
        _c("div", { staticClass: "order-image" }, [
          _c("img", {
            attrs: { src: order.image.sizes.medium_large, alt: order.title }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order-content" }, [
          _c("h3", { domProps: { innerHTML: _vm._s(order.title) } }),
          _vm._v(" "),
          order.categories && order.categories.length > 0
            ? _c(
                "div",
                {
                  key: order.categories.length,
                  ref: "categories",
                  refInFor: true,
                  staticClass: "tag-row d-none d-xl-flex mt-16"
                },
                _vm._l(order.categories, function(category, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "tags",
                      refInFor: true,
                      staticClass: "tag-col"
                    },
                    [
                      _c("div", {
                        staticClass: "tag tag-accent-light tag-xs",
                        domProps: { innerHTML: _vm._s(category) }
                      })
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.canDelete
          ? _c(
              "div",
              {
                staticClass: "order-delete xsmall",
                on: {
                  click: function($event) {
                    return _vm.removeOrder(order.ID)
                  }
                }
              },
              [
                _c("span", { staticClass: "mr-8 my-auto font-weight-bold" }, [
                  _vm._v("Verwijder")
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "my-auto",
                  domProps: { innerHTML: _vm._s(_vm.svg("trash")) }
                })
              ]
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }